// extracted by mini-css-extract-plugin
export var pickerModal = "_bs-0";
export var xButton = "_bs-1";